import { FC, ReactElement } from 'react'

import { trans } from '@/helpers/trans'
import { LogResource } from '@/models'

import { TrackLog } from './subcomponents/TrackLog'

import './TrackLogs.scss'

interface TrackLogsProps {
    logs?: LogResource[]
}

export const TrackLogs: FC<TrackLogsProps> = ({ logs }): ReactElement | null => {
    if (! logs || logs.length <= 1) {
        return null
    }

    return (
        <>
            <div className="track-logs__title">
                {trans('pages.logs.changes')}
            </div>
            <ul className="mb-4 border-top list-group logs">
                {logs.map(log => (
                    <TrackLog
                        {...log.changes}
                        key={log.id}
                        actor={log.actor?.fullName || trans('common.unknown')}
                        loggedAt={log.loggedAt}
                    />
                ))}
            </ul>
        </>
    )
}
